// Loading screen: the code of every section (page-loaders.ts loadPages), so a section's first open has no
// wait. Only in a build: `npm run dev` has no chunks (every module is served on its own).
import { loadPages } from './page-loaders';
import { defineWarmup } from './warmup/step';

export const warmup = defineWarmup({
  id: 'sections',
  order: 300,
  label: 'sections',
  dev: false,
  run: ({ progress }) => loadPages(progress),
});
